import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { filterProfilesForPlaybook, toProfilesResponse } from "../helpers/accessLevelFilters";
import type { ProfilesResponseDto } from "../types/dto";

import { contactsSearchProfilesQueryKeys } from "./queryKeyFactory";

export const usePlaybookProfilesQuery = (isSharedWithAccount: boolean) => {
    return useQuery({
        queryKey: contactsSearchProfilesQueryKeys.allProfiles(),
        staleTime: 0,
        refetchOnMount: true,
        placeholderData: keepPreviousData,
        queryFn: () => salesApiService.contactsSearchProfiles.fetchAllProfiles(),
        select: (data: ProfilesResponseDto): ProfilesResponseDto => {
            const profiles = filterProfilesForPlaybook(data.profiles, isSharedWithAccount);
            return toProfilesResponse(profiles);
        },
    });
};
